import React, { useState } from 'react'

import Tooltip from '@components/shared/Tooltip'
import EmbedTitleDialog from '@components/shared/dialogs/EmbedTitleDialog'

import ShareMenu from './ShareMenu'
import SocialIcon from './SocialIcon'

import 'tippy.js/dist/tippy.css'

const Share: React.FC = () => {
  const [showMenu, setShowMenu] = useState(false)

  return (
    <>
      <Tooltip
        arrow
        onClickOutside={() => setShowMenu(false)}
        content={<ShareMenu onClick={() => setShowMenu(false)} />}
        onHide={() => setShowMenu(false)}
        interactive
        placement="bottom"
        visible={showMenu}>
        {/* span?? Tippy doesn't allow for its direct child to be a functional component */}
        <span>
          <SocialIcon
            className="nf-share text-black-dark dark:text-gray hover:text-orange"
            onClick={() => setShowMenu(true)}
          />
        </span>
      </Tooltip>
      <EmbedTitleDialog />
    </>
  )
}

export default Share
